import React, { useState } from "react";
import { Helmet } from "react-helmet";
import {
  setUserSession,
  setUserApp,
  setUserid,
  setUser,
} from "../../api/common";
import Loader from "../loader/loader";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getUserApi } from "../../api/api";
import "./material.css";

const Login = (props) => {
  const email = useFormInput("");
  const password = useFormInput("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    const emails = email.value;
    const passwords = password.value;

    // Logging into the application
    const token_set = await getUserApi(emails, passwords).then(
      (response) => {
        return response;
      },
      (error) => {
        return error;
      },
      [props]
    );

    // Get Token and Error Count
    if (token_set) {
      var tokencount = Object.keys(token_set).length;
      if (token_set.status === 200 && tokencount > 0) {
        const token = token_set.data.token;
        const user = token_set.data.user;
        const application = token_set.data.application;
        setLoading(false);
        setUserSession(token);
        setUserApp(application);
        setUser(user);
        setUserid(user);
        window.location.href = "/dashboard";
      } else {
        setLoading(false);
        if (token_set.status === 401 || token_set.status === 400) {
          password.value = "";
          email.value = "";
          setError(token_set.data.error.message);
          toastr.error(error, token_set.data.error.message);
        } else {
          password.value = "";
          email.value = "";
          setError("Something went wrong. Please try again later.");
          toastr.error("Internal Server Error", "Error!");
        }
      }
    } else {
      setLoading(false);
      password.value = "";
      email.value = "";
      toastr.error(
        "Something went wrong while logging in. Please try again.",
        "Error!"
      );
    }
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="Main-page" style={{ top: "55px" }}>
        <Helmet>
          <body className="hold-transition login-page background-2" />
        </Helmet>
        <div>
          <div className="container">
            <div className="screen">
              <div className="screen__content">
                <form
                  className="login"
                  style={{ paddingTop: "75px" }}
                  onSubmit={handleSubmit}
                >
                  <div className="login-logo" style={{ textAlign: "left" }}>
                    <a href="#!" style={{ color: "#000000" }}>
                      <img
                        src="/dist/img/Primary Logo.png"
                        alt="mainlogo"
                        style={{ height: "55px", width: "auto" }}
                      ></img>
                      <small
                        style={{
                          fontSize: "55%",
                          verticalAlign: "text-bottom",
                          fontWeight: "bold",
                        }}
                      >
                        Console
                      </small>{" "}
                    </a>
                  </div>
                  <div className="login__field">
                    <i className="login__icon fas fa-user" />
                    <input
                      type="email"
                      name="email"
                      className="login__input"
                      placeholder="Email"
                      {...email}
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="login__field">
                    <i className="login__icon fas fa-lock" />
                    <input
                      type="password"
                      name="password"
                      className="login__input"
                      placeholder="Password"
                      {...password}
                      required
                      autoComplete="off"
                    />
                  </div>
                  <button type="submit" className="button login__submit">
                    <span className="button__text">Log In Now</span>
                    <i className="button__icon fas fa-chevron-right" />
                  </button>
                </form>
                <div className="social-login">
                  {/* <h3>log in via</h3>
          <div className="social-icons">
            <a href="#" className="social-login__icon fab fa-instagram" />
            <a href="#" className="social-login__icon fab fa-facebook" />
            <a href="#" className="social-login__icon fab fa-twitter" />
          </div> */}
                </div>
              </div>
              <div className="screen__background">
                <span className="screen__background__shape screen__background__shape4" />
                <span className="screen__background__shape screen__background__shape3" />
                <span className="screen__background__shape screen__background__shape2" />
                <span className="screen__background__shape screen__background__shape1"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default Login;
